import React, { useState } from "react";
import useCountdown from "../../../hooks/useCountdown";
import OtpInput from "react-otp-input";
import { useTranslate } from "@tolgee/react";
import {
  Hero, Globe, Title, Subtitle,
  Fields, PrimaryBtn, BackBtn, EmailBadge, ErrorText, TextLink,
  OtpWrapper, OtpBox, ResendSuccess, ResendTimer, TermsFooter,
} from "../shared/AuthUI";
import {
  sendRegistrationOtp,
  sendPasswordResetOtp,
  sendSetPasswordOtp,
  verifyOtp,
} from "../../../API/emailAuth";
import { getAuthErrorMessage } from "../../../API/emailAuthErrors";

const FLOW_CONFIG = {
  register: { globe: "✉️", titleKey: "authentication.otp.verify_email_title" },
  reset: { globe: "🔑", titleKey: "authentication.otp.reset_password_title" },
  "set-password": { globe: "🔑", titleKey: "authentication.otp.set_password_title" },
};

const EmailOtpStep = ({
  email,
  flow,
  onBack,
  onVerified,
  setIsLoading,
}) => {
  const { t } = useTranslate();
  const [otp, setOtp] = useState("");
  const [error, setError] = useState(null);
  const [resent, setResent] = useState(false);
  const [countdown, resetCountdown] = useCountdown(30);

  const { globe, titleKey } = FLOW_CONFIG[flow] || FLOW_CONFIG.register;

  const handleVerify = (code) => {
    const val = code || otp;
    if (val.length !== 6) return;
    setError(null);
    setIsLoading(true);
    verifyOtp(
      email,
      val,
      flow,
      () => { setIsLoading(false); onVerified(val); },
      (err) => {
        setIsLoading(false);
        setOtp("");
        setError(getAuthErrorMessage(err?.response?.data?.error, t));
      }
    );
  };


  const handleResend = () => {
    setResent(false);
    setIsLoading(true);
    const resendFn =
      flow === "register" ? sendRegistrationOtp :
      flow === "reset" ? sendPasswordResetOtp :
      sendSetPasswordOtp;

    resendFn(
      email,
      () => { setIsLoading(false); setResent(true); resetCountdown(); },
      () => { setIsLoading(false); setError(t("authentication.otp.resend_failed")); }
    );
  };

  return (
    <>
      <BackBtn onClick={onBack}>{t("general.back")}</BackBtn>

      <Hero>
        <Globe>{globe}</Globe>
        <Title>{t(titleKey)}</Title>
        <Subtitle>{t("authentication.otp.email_subtitle")}</Subtitle>
      </Hero>

      <EmailBadge>{email}</EmailBadge>

      <Fields>
        <OtpWrapper>
          <OtpInput
            containerStyle={{ display: "flex", justifyContent: "space-between", width: "100%", gap: "8px" }}
            shouldAutoFocus
            value={otp}
            onChange={(val) => { setOtp(val); setError(null); if (val.length === 6) handleVerify(val); }}
            numInputs={6}
            renderSeparator={null}
            renderInput={(props) => <OtpBox {...props} error={!!error} />}
          />
        </OtpWrapper>

        {error && <ErrorText>{error}</ErrorText>}
        {resent && <ResendSuccess>{t("authentication.otp.resend_success_email")}</ResendSuccess>}

        <PrimaryBtn disabled={otp.length < 6} onClick={() => handleVerify(otp)}>
          {t("authentication.otp.verify_button")}
        </PrimaryBtn>

        {countdown > 0
          ? <ResendTimer>{t("authentication.otp.resend_timer", { countdown })}</ResendTimer>
          : <TextLink onClick={handleResend}>{t("authentication.otp.resend_link")}</TextLink>
        }
      </Fields>

      <TermsFooter />
    </>
  );
};

export default EmailOtpStep;
